export default "__VITE_ASSET__CcJ4wjet__"